export default "__VITE_ASSET__OQ797JDT__"